import React from 'react';
import classNames from 'classnames';
import cls from './InformationRow.module.css';
import { NotGivenRow } from '../NotGivenRow/NotGivenRow';

interface InformationRowProps {
    title: string;
    text: string;
    classes?: string;
}

export const InformationRow = ({ classes, title, text }: InformationRowProps) => {
    return (
        <div className={classNames(cls.InformationRow, [classes])}>
            <span className={cls.title}>{title}</span>
            {text ? (
                <span className={cls.text}>{text}</span>
            ) : (
                <NotGivenRow
                    text={
                        title === i18next.t('InformationRow.return.NotGivenRow.description')
                            ? i18next.t('InformationRow.return.NotGivenRow.notGiven')
                            : undefined
                    }
                />
            )}
        </div>
    );
};
